var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineShoppingCartBigCircle64Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.326 33.5006C38.451 33.5006 39.441 32.8856 39.951 31.9556L45.321 22.2206C45.876 21.2306 45.156 20.0006 44.016 20.0006H21.816L20.406 17.0006H15.501V20.0006H18.501L23.901 31.3856L21.876 35.0456C20.781 37.0556 22.221 39.5006 24.501 39.5006H42.501V36.5006H24.501L26.151 33.5006H37.326ZM23.241 23.0006H41.466L37.326 30.5006H26.796L23.241 23.0006ZM24.501 41.0006C22.851 41.0006 21.516 42.3506 21.516 44.0006C21.516 45.6506 22.851 47.0006 24.501 47.0006C26.151 47.0006 27.501 45.6506 27.501 44.0006C27.501 42.3506 26.151 41.0006 24.501 41.0006ZM39.501 41.0006C37.851 41.0006 36.516 42.3506 36.516 44.0006C36.516 45.6506 37.851 47.0006 39.501 47.0006C41.151 47.0006 42.501 45.6506 42.501 44.0006C42.501 42.3506 41.151 41.0006 39.501 41.0006Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineShoppingCartBigCircle64Px);
export default __webpack_public_path__ + "static/media/ic-outline-shopping_cart_big_circle-64px.dc04857f8c600400467975df6c8bb365.svg";
export { ForwardRef as ReactComponent };